import _ from 'lodash';

import { transport } from '../../transport';
import { APPLICATION_PATH, BASE_PATH, PROJECT_PATH } from '../config';
import { WixMpResponse } from '../../../types/http-responses';
import { Application } from '../../../types/entities';

const prepareApplication = (application: Application) => {
  const sortedSecrets = _.orderBy(
    application.sharedSecrets,
    (sharedSecret) => new Date(sharedSecret.activationDate),
    'desc',
  );
  return {
    ...application,
    // TODO: get real creation date from BE
    creationDate: _.last(sortedSecrets).activationDate,
    sharedSecrets: sortedSecrets.slice(0, 2),
  };
};

function getApplications({ organizationId, projectId }) {
  return transport
    .get<WixMpResponse<Application[]>>(
      `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}`,
    )
    .then(
      (response) => {
        response.data.payload = _(response.data.payload)
          .map((application) => prepareApplication(application))
          .orderBy((application) => new Date(application.creationDate), 'desc')
          .value();
        return response;
      },
      (reason) => Promise.reject(reason),
    );
}

function getApplication({ organizationId, projectId, applicationId }) {
  return transport.get<WixMpResponse<Application>>(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}/${applicationId}`,
  );
}

function createApplication(application, { organizationId, projectId }) {
  return transport
    .post<WixMpResponse<Application>>(
      `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}`,
      application,
    )
    .then(
      (response) => {
        response.data.payload = prepareApplication(response.data.payload);
        return response;
      },
      (reason) => Promise.reject(reason),
    );
}

// TODO: talk with backend guys to extend this method (now only update for 'name' is available)
function updateApplication(
  application,
  { organizationId, projectId, applicationId },
) {
  const { name } = application;
  const path = `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}/${applicationId}/name/${name}`;
  return transport.put(path);
}

function deleteApplication({ organizationId, projectId, applicationId }) {
  const path = `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}/${applicationId}`;
  return transport.delete(path);
}

function generateNewSecret({ organizationId, projectId, applicationId }) {
  const path = `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}/${applicationId}/generate_secret`;
  return transport.post<WixMpResponse<Application>>(path).then(
    (response) => {
      response.data.payload = prepareApplication(response.data.payload);
      return response;
    },
    (reason) => Promise.reject(reason),
  );
}

export const applicationService = {
  getApplication,
  getApplications,
  createApplication,
  updateApplication,
  deleteApplication,
  generateNewSecret,
};
